<template>
	<div class="comp share-panel-comp">
		<div class="main-wrap">
			<div class="title">分享</div>
			<div class="icon-wrap">
				<div class="icon-item"
					 @click="shareByWechat">
					<img class="icon-img"
						 src="../assets/images/wechat3.png" />
					<div class="icon-text">微信</div>
				</div>
				<div class="icon-item"
					 @click="shareByMoment" v-show="hasShare">
					<img class="icon-img"
						 src="../assets/images/moment.png" />
					<div class="icon-text">朋友圈</div>
				</div>
				<div class="icon-item"
					 @click="shareByQQ">
					<img class="icon-img"
						 src="../assets/images/QQ.png" />
					<div class="icon-text">QQ</div>
				</div>
				<div class="icon-item"
					 @click="shareByWeibo" v-show="hasShare">
					<img class="icon-img"
						 src="../assets/images/weibo.png" />
					<div class="icon-text">微博</div>
				</div>
			</div>
		</div>
		<div class="cancel-btn" @click="onCancel">取消</div>
	</div>
</template>

<script>
import apiUtil from '../utils/apiUtil';
import apiConst from '../consts/apiConst';
import greenLogo from './../assets/images/logo_greenlv.jpg';
import { getUser } from '../utils/storageUtil';
export default {
	name: 'sharePanel',
	props: {
		shareByWechat: {
			type: Function,
			default: () => {}
		},
		shareByMoment: {
			type: Function,
			default: () => { }
		},
		shareByQQ: {
			type: Function,
			default: () => { }
		},
		shareByWeibo: {
			type: Function,
			default: () => { }
        },
		content:{
			type:String
		},
		cover:{
			type:String
		},
		title:{
			type:String
		},
		contentType:{
			type:Number
		},
		dataType:{
			type:Number	
		},
		hasShare:{
			type:Boolean,
			default:true
		}
    
  },
	data(){
		return {
			// hasShare:true
			yqcode:'',
			user: null,
			online:'https://app.igreen.org/'
		}
	},
	created:function(){
		this.dyShare();
		const user = getUser()
		this.user = user;
	},
  methods: {
    onCancel(){
      this.$emit('cancel')
    },
	  dyShare(){
		  if(this.hasShare){
			  this.getShare(this.$route.query.id)
		  }else{
			  this.getExperience();
		  }
	  },
	  shareByWechat(){ 
		  this.shareMethod(1)
		  this.$emit('cancel')
	  },
	  shareByMoment(){		  
		  this.shareMethod(2)
		  this.$emit('cancel')
	  },
	  shareByQQ(){
		  this.shareMethod(3)
		  this.$emit('cancel')
	  },
	  shareByWeibo(){
		  this.shareMethod(4)
		  this.$emit('cancel')
	  },
	  shareMethod(param){
		  let position = param;
		  let title='';
		  let content='';
		  let imageUrl='';
		  let url = '';
		  if(this.contentType==1){
			  title = this.title;
			  content = this.title;
			  imageUrl = this.cover;
			  url = this.online+window.location.hash+'&openFlag=1';

		  }else if(this.contentType==3){
		  	if (!this.user) {
				this.$router.push('login');
				return;
			}
			  title = '友绿';
			  content = '助力房地产全产业链科技创新';
			  imageUrl = this.online+greenLogo;
			  url = this.online + '#/share?fxcode='+this.yqcode;

		  }else{
		  	if (!this.user) {
				this.$router.push('login');
				return;
			}
			  title = this.$route.query.title;
			  content = this.$route.query.title;
			  imageUrl = this.$route.query.cover;
			  //url = window.location.origin + window.location.pathname + '#/share?fxcode='+this.yqcode;
			  url=this.online + '#/share?fxcode='+this.yqcode;
		  }
		  window.HostApp.share(position,title,content,imageUrl,url)
	  },
	  async getShare(course_id){
		  const res = await apiUtil.post(apiConst.share,{course_id:course_id});
		  if (res.success) {
			  this.yqcode = res.code;
		  }
	  },
	  async getExperience(){
		  const res = await apiUtil.post(apiConst.getExperience);
		  let _self=this;
		  if (res.success) {
			  _self.yqcode = res.code;
		  }
	  },

  }
}
</script>
<style lang="stylus" scoped>
.share-panel-comp {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 999;

	.cancel-btn {
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
		height: 114px;
		background: rgba(255, 255, 255, 1);
		border-radius: 26px;
    line-height: 114px;
    text-align: center;
    color: #8FC31E;
    font-size: 40px;
	}

	.main-wrap {
		position: absolute;
		left: 20px;
		right: 20px;
		bottom: 144px;
		border-radius: 26px;
		height: 347px;
		overflow: hidden;
		background-color: #fff;

		.title {
			height: 104px;
			background-color: #FCFCFC;
			line-height: 104px;
			color: #8F8E94;
			font-size: 26px;
			border-bottom: 1px solid rgba(77, 77, 77, 0.78);
			text-align: center;
			font-weight: bold;
		}

		.icon-wrap {
			height: 243px;
			display: flex;
			align-items: center;
			justify-content: space-around;
			padding: 0 40px;

			.icon-item {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;

				.icon-img {
					width: 100px;
					height: 100px;
					margin-bottom: 20px;
				}

				.icon-text {
					font-size: 28px;
					color: #333;
				}
			}
		}
	}
}
</style>


